module.exports = __webpack_public_path__ + "img/Mateusz.362a3aa4.jpg";